import { useState } from 'react';
import { TableCell, TableRow, Chip, Rating, useMediaQuery } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';
import AndroidIcon from '@mui/icons-material/Android';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { CommentCommand } from '../../../../../services/command';
import Swal from 'sweetalert2';
import StyleVariables from '../../../../../assets/styles/variables/_export.module.scss';
import { SCUIGeneralDrawer } from '../../../SCUIGeneralDrawer/SCUIGeneralDrawer';
import { SCUIProductCommentDetailFormV2 } from '../../SCUIProductCommentDetailFormV2';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

function ProductCommentListTableBody({ datas, setRowData, rowData, refetchGridData }: any) {
    const [commentDetailShow, setCommentDetailShow] = useState(false);
    const [commentDetailId, setCommentDetailId] = useState(0);

    const enumCommentName: any = {
        1: t('general.waitingForApproval'),
        2: t('general.approved'),
        3: t('general.declined'),
    };

    const isTablet = useMediaQuery(`(max-width:  ${StyleVariables.breakpointMd})`, { noSsr: true });

    const handleOpenDrawer = () => {
        setCommentDetailId(datas?.id);
        setCommentDetailShow(true);
    };

    const handleDrawerClose = () => {
        setCommentDetailShow(false);
    };

    // Helper function to show error alert
    const showErrorAlert = () => {
        Swal.fire({
            icon: 'error',
            title: t('general.error'),
            showConfirmButton: false,
            timer: 1500,
        });
    };

    // Helper function to handle successful assignment
    const handleSuccessfulAssignment = (rowInfo: any, res: any) => {
        setCommentDetailId(rowInfo?.id);
        setCommentDetailShow(true);
        const tempRowData = [...rowData];
        const index = tempRowData.findIndex((row: any) => row.id === rowInfo?.id);
        tempRowData[index].operator = res?.operatorName?.toLowerCase();
        setRowData(tempRowData);
    };

    // Helper function to get status color
    const getStatusColor = (statusId: number) => {
        const statusColors: { [key: number]: 'success' | 'error' | 'warning' | 'default' } = {
            1: 'warning',
            2: 'success',
            3: 'error',
        };
        return statusColors[statusId] || 'default';
    };

    const postAssignToMe = async (rowInfo: any): Promise<any> => {
        const params = {
            rowId: Number(rowInfo?.id),
            assignedOperator: rowInfo?.operator,
            status: Number(rowInfo?.status),
        };

        CommentCommand.PostAssigToMeV2(params)
            .then((res: any) => {
                if (res?.isSuccess) {
                    handleSuccessfulAssignment(rowInfo, res);
                } else {
                    showErrorAlert();
                }
            })
            .catch((error: any) => {
                showErrorAlert();
                console.log('Hata :>> ', error);
            });
    };

    return (
        <TableRow
            sx={{ minHeight: '8px' }}
            style={{
                boxShadow:
                    '0px 4px 8px rgba(0, 0, 0, 0.05), -4px 0px 8px rgba(0, 0, 0, 0.05), 4px 0px 8px rgba(0, 0, 0, 0.05), 0px -4px 8px rgba(0, 0, 0, 0.05)',
            }}
        >
            <TableCell style={{ borderBottom: 'none', textAlign: 'center', width: '6%' }}>
                <SCUIGeneralDrawer
                    open={commentDetailShow}
                    anchor="right"
                    width={isTablet ? '100%' : '60%'}
                    onClose={(_: any, reason: any) => {
                        if (reason === 'backdropClick') {
                            handleDrawerClose();
                        }
                    }}
                >
                    <SCUIProductCommentDetailFormV2
                        id={commentDetailId}
                        onClose={handleDrawerClose}
                        rowData={rowData}
                        setRowData={setRowData}
                        onUpdate={() => refetchGridData()}
                    />
                </SCUIGeneralDrawer>
                <>
                    <p>{datas.id}</p>
                </>
            </TableCell>
                <TableCell style={{ borderBottom: 'none', textAlign: 'center', width: '10%' }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'center',
                        }}
                    >
                        <div>
                            <b>{datas.brandName}</b>
                        </div>
                        <div> {datas.special + ' - ' + datas.colorCode}</div>
                        <div>
                            {' '}
                            <Rating name="read-only" value={datas.starScore} readOnly />
                        </div>
                    </div>
                </TableCell>
                <TableCell
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '13%',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                    }}
                >
                    {datas.mail}
                </TableCell>
                <TableCell
                    align="center"
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '5%',
                    }}
                >
                    {datas.grievanceStatus.id === 1 ? (
                        <Tooltip title="Mağduriyet var">
                            <CheckCircleIcon color="error" />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Mağduriyet yok">
                            <p>-</p>
                        </Tooltip>
                    )}
                </TableCell>
                <TableCell
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '7%',
                    }}
                >
                    {datas.operator}
                </TableCell>
                <TableCell
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '9%',
                    }}
                >
                    {datas.createDate}
                </TableCell>
                <TableCell
                    style={{
                        borderBottom: 'none',
                        textAlign: 'center',
                        width: '10%',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                    }}
                >
                    {' '}
                    <Tooltip title={datas.tag}>
                        {datas.tag.length < 20 ? datas.tag : datas.tag.slice(0, 20) + '...'}
                    </Tooltip>
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '6%' }}>
                    {datas.isAgent === true ? (
                        <SupportAgentIcon sx={{ cursor: 'default', width: 20, height: 20 }} />
                    ) : (
                        <AndroidIcon style={{ color: 'turquoise' }} />
                    )}
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '6%' }}>
                    {datas.threshold}
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '5%' }}>
                    {datas.labelProp}
                </TableCell>
                <TableCell style={{ borderBottom: 'none', textAlign: 'center', width: '5%' }}>
                    <>
                        {datas.IsImagesComment === true ? (
                            <Tooltip title="Fotoğraflı yorum var">
                                <CheckCircleIcon color="success" />
                            </Tooltip>
                        ) : (
                            <Tooltip title="Fotoğraflı yorum yok">
                                <CancelIcon color="error" />
                            </Tooltip>
                        )}
                    </>
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '8%' }}>
                    <Chip
                        label={enumCommentName[datas.commentStatus.id] || ''}
                        color={getStatusColor(datas.commentStatus.id)}
                    />
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '4%' }}>
                    <AssignmentIcon className="cursorPointer" onClick={handleOpenDrawer} />
                </TableCell>
                <TableCell align="center" style={{ borderBottom: 'none', textAlign: 'center', width: '6%' }}>
                    <AssignmentIndIcon className="cursorPointer" onClick={() => postAssignToMe(datas)} />
                </TableCell>
            </TableRow>
    );
}

export default ProductCommentListTableBody;
